<template>
  <div class="form__formrow">
    <p :class="{ ' form__row': returnEnvelopeCheck }">
      <span class="modal__control_label text--left">
        {{ this.config.lang["modal.control.return-envelope-header"] }}
        <img
          class="ebrief-tooltip tipso_style upload__section_header_tooltip"
          src="/build/images/info-circle-darkgrey.svg"
          data-tipso-key="return-envelope"
          data-tipso-moveleft="2"
          data-tipso-movetop="1"
          alt="Info"
          style="left: 7px; position: relative; top: 3px; height: 16px"
        />
      </span>
      <label
        for="bulk-parameter-return-envelope"
        class="form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline"
      >
        <input
          class="form__pincheckbox-input"
          type="checkbox"
          id="bulk-parameter-return-envelope"
          name="bulk-parameter-return-envelope"
          v-model="returnEnvelopeCheck"
          @change="updateParent"
        />
        <span class="form__pincheckbox-border"></span>
        <span
          class="form__pincheckbox-label form__pincheckbox-label--colorblue"
        >
          <span class="text--content-bold">
            {{ this.config.lang["modal.control.return-envelope-checkbox-pt1"] }}
            <br v-if="returnEnvelopeCheck" />
            <span
              v-html="
                this.config.lang['modal.control.return-envelope-checkbox-pt2']
              "
            >
            </span>
          </span>
        </span>
      </label>
      <label
        v-if="returnEnvelopeCheck"
        for="bulk-parameter-envelopetype"
        class="modal__control_label--return-envelope "
      >
        {{ this.config.lang["modal.control.return-envelope-franking-header"] }}
      </label>
      <select
        id="bulk-parameter-envelopetype"
        name="parameter-envelopetype"
        class="js-ms-dropdown form__select--modalcontrol form__hide"
        v-model="envelopeType"
        @change="updateParent"
      >
        <option
          v-for="option in this.config.printparameter.bulk.envelopeType.select"
          :value="option.value"
        >
          {{ option.text }}
        </option>
      </select>
    </p>

    <p class="form__row --right" v-if="returnEnvelopeCheck">
      <label
        for="bulk-parameter-return-address"
        class="modal__control_label--return-envelope"
      >
        {{ this.config.lang["modal.control.return-envelope-textarea-header"] }}
      </label>

      <textarea
        id="bulk-parameter-return-address"
        name="parameter-return-address"
        class="dd form__field--textarea-address "
        maxlength="200"
        v-model="returnAddress"
        :placeholder="
          this.config.lang['modal.control.return-envelope-textarea-placeholder']
        "
        rows="3"
        @input="updateParent"
      >
      </textarea>
      <span
        class="modal__control_label--char-count"
        :class="{
          ' --warning': addressCharLeft <= 10
        }"
      >
        noch {{ addressCharLeft }} Zeichen
      </span>
    </p>
  </div>
</template>
<script>
import ValidationService from "../services/ValidationService";

export default {
  name: "ReturnEnvelope",
  components: {},
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      validation: new ValidationService(configdata),
      returnEnvelopeCheck: false,
      envelopeType: "RU1",
      returnAddress: configdata.printparameter.bulk.returnAddress ?? "",
      addressCharLeft:
        200 - configdata.printparameter.bulk.returnAddress?.length ?? 0
    };
  },
  watch: {
    returnAddress() {
      this.$emit("remove-error");
      if (this.returnAddress.includes(",")) {
        this.$emit(
          "add-validation-error",
          this.config.lang[
            "modal.control.return-envelope-address-no-comma-allowed"
          ]
        );
      }
      this.addressCharLeft = 200 - this.returnAddress.length;
    }
  },
  computed: {
    config: function() {
      return configdata;
    }
  },
  methods: {
    setDefaults() {
      this.returnEnvelopeCheck = false;
      this.envelopeType = "RU1";
      this.returnAddress = this.config.printparameter.bulk.returnAddress ?? "";
      $("#bulk-parameter-envelopetype")
        .msDropdown()
        .data("dd")
        .set("selectedIndex", 0);

      $("#bulk-parameter-envelopetype_msdd").css("display", "none");
    },

    updateParent() {
      this.$emit("input", {
        returnEnvelopeCheck: this.returnEnvelopeCheck,
        envelopeType: this.envelopeType,
        returnAddress: this.returnAddress
      });
    }
  },
  mounted() {
    let that = this;
    $("#bulk-parameter-envelopetype")
      .msDropdown({ visibleRows: 3 })
      .change(function() {
        that.envelopeType = $(
          "#bulk-parameter-envelopetype option:selected"
        ).val();
      });

    // these here are needed to show and hide the return envelop select based on the checkbox
    // standard way doesn't work because 'msDropdown' creates a new element see "_msdd" suffix
    $("#bulk-parameter-envelopetype_msdd").css("display", "none");
    $("#bulk-parameter-return-envelope").on("change", function() {
      $("#bulk-parameter-envelopetype_msdd").css("display", function() {
        return that.returnEnvelopeCheck ? "block" : "none";
      });
    });
  }
};
</script>
